// keep the v4 object key name so we can mock and statically declare value for unit tests
import { v4 } from 'uuid'

export default (): string => v4().toLowerCase()
